import Image from 'next/image';
import Link from 'next/link';
import { ReactNode } from 'react';
import { useMeasure, useWindowSize } from 'react-use';
import { useIsRouting } from 'src/hooks/useIsRouting';
import LoadingOverlay from 'src/shared-components/Loading/LoadingOverlay';

const BackgroundImageLayout = ({
  children,
  backgroundImage,
  isLoading = false,
}: {
  children?: ReactNode;
  backgroundImage: string;
  isLoading?: boolean;
}) => {
  const { height: windowHeight } = useWindowSize();
  const [whiteContainerRef, { height: whiteContainerHeight }] = useMeasure<HTMLDivElement>();
  const isRouting = useIsRouting();

  return (
    <div
      data-testid="container"
      className={`${backgroundImage} pb-10 h-auto sm:h-screen bg-cover pt-10`}
      style={{ height: whiteContainerHeight < windowHeight - 100 ? '100vh' : 'auto' }}
    >
      <Link href={'http://www.huddle.works'}>
        <a>
          <div className="mb-8 flex justify-center items-center">
            <Image src={'/images/logo.svg'} alt="Huddle Logo" height={37} width={87} />
          </div>
        </a>
      </Link>
      <div className="m-auto w-11/12 md:max-w-lg bg-white rounded-lg py-8 px-6 relative" ref={whiteContainerRef}>
        {(isLoading || isRouting) && <LoadingOverlay />}
        {children}
      </div>
    </div>
  );
};

export default BackgroundImageLayout;
